import { useEffect, useState } from 'react';
import { api } from './api';

/**
 * Ist das angemeldete Konto Admin? (7.226) -- für die Stellen im Schnittplatz,
 * an denen die Kontorolle zählt und nicht die Rolle im Projekt: Markensets
 * ändern nur Admins, wie „Wer darf was“ es sagt. `null`, solange die Antwort
 * aussteht; dann gilt, was am wenigsten erlaubt.
 */
export function useIstAdmin(): boolean | null {
  const [ja, setJa] = useState<boolean | null>(null);
  useEffect(() => {
    let weg = false;
    api
      .me()
      .then((r) => !weg && setJa(r.user.role === 'admin'))
      .catch(() => !weg && setJa(false));
    return () => {
      weg = true;
    };
  }, []);
  return ja;
}
